export interface ServiceConfig {
  javaApiUrl: string;
  exchangeDealsUrl: string;
  authenticationServerUrl: string;
}
